<template>
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" >
            <van-swipe-item v-for="(item, index) in swipedata" :key="index">
                <img :src="item" width="100%"/>
            </van-swipe-item>
        </van-swipe>
</template>

<script>
    export default {
        name: "Swipe",
        data(){
            return{


            }
        },
        props:{
            swipedata:{
                type:Array,
                required:true
            }
        },
    }
</script>

<style scoped lang="scss">
     .my-swipe {
         overflow: hidden;
         width: 92%;
         height: 0;
         margin: 10px auto;
         padding-bottom: 24%;
         color: #fff;
         font-size: 20px;
         border-radius: 10px;
         text-align: center;

     }



</style>
